/**
 * Notification module entities.
 */
export enum NotificationEntities {
  /** Global notification content (shared across users). */
  Notification = "Notification",
  /** Per-user notification receipt under User. */
  UserNotification = "UserNotification",
}
